import get from "lodash/get";
import { Children, HTMLAttributes, isValidElement } from "react";

import { NoDataTable } from "src/components";

type TableBodyProps = HTMLAttributes<HTMLTableSectionElement> & {
  /**
   * data is array of object that will be mapped
   */
  data: any[];
};

function TableBody({ data, children: Row, ...props }: TableBodyProps) {
  const emptyTable = (
    <tbody>
      <NoDataTable />
    </tbody>
  );

  if (!data) return emptyTable;
  if (!Array.isArray(data)) return emptyTable;
  if (Array.isArray(data) && data.length === 0) return emptyTable;

  const isRenderProp = typeof Row === "function";
  const isReactElement = isValidElement(Row);

  return (
    <tbody {...props}>
      {data.map((item, index) => {
        const propsRow = isRenderProp ? (isReactElement ? Row.props : Row({ ...item }, index).props) : {};
        return (
          <tr key={item.id ? `row_${item.id}_${index}` : `row_${index}`} {...propsRow}>
            {Children.map(
              isRenderProp ? Row({ ...item }, index).props.children : isReactElement ? Row.props.children : Row,
              (Col, idx) => {
                const { dataKey, ...childProps } = Col.props;
                const columnValue = dataKey ? get(item, dataKey, Col.props.defaultValue || "") : Col.props?.children;

                return (
                  <td {...childProps} key={`row_${index}_col_${idx}`}>
                    {typeof Col.props.children === "function" ? Col.props.children({ ...item }, index) : columnValue}
                  </td>
                );
              }
            )}
          </tr>
        );
      })}
    </tbody>
  );
}

type TableColProps = HTMLAttributes<HTMLTableCellElement> & {
  /**
   * dataKey is the key of the data in the mapped object item
   */
  dataKey?: string;

  /**
   * defaultValue is the fallback value for the selected column
   */
  defaultValue?: string;
};

TableBody.Row = (_props: HTMLAttributes<HTMLTableRowElement>): null => null;
TableBody.Col = (_props: TableColProps): null => null;

export default TableBody;
